import $ from 'jquery';
import 'slick-carousel';

$(document).ready(function () {
  $('.brandhub-slider-section:not(.author-mode)').each(function (i) {
    var elem = $(this);
    var listElem = elem.find('.brandhub-slider-list');
    var dotElems = elem.find('.mbic-slider-dots__dot');

    listElem.on('afterChange', function (event, slick, newSlide) {
      dotElems.removeClass('mbic-slider-dots__dot-active');
      $(dotElems[newSlide]).addClass('mbic-slider-dots__dot-active');
    });
  });
});



// WEBPACK FOOTER //
// ./src/components/slider/slider-custom.js